"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _DataTable = require("../DataTable");
var _TableHeaderCell = require("./TableHeaderCell.styled");
var _NotifyIcon = _interopRequireDefault(require("../../NotifyIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var TableHeaderCell = function TableHeaderCell(_ref) {
  var children = _ref.children,
    sortable = _ref.sortable,
    colId = _ref.colId,
    orderByColId = _ref.orderByColId,
    order = _ref.order,
    align = _ref.align,
    _onClick = _ref.onClick,
    styles = _ref.styles;
  var tableArrow = 'unusedTableArrow';
  if (colId === orderByColId) {
    tableArrow = order === _DataTable.ORDER_ASC ? 'tableUpArrow' : 'tableDownArrow';
  }
  var childrenWithSortLabel = sortable ? /*#__PURE__*/_react["default"].createElement(_material.TableSortLabel, {
    active: colId === orderByColId,
    direction: colId === orderByColId ? order : _DataTable.ORDER_ASC,
    onClick: function onClick(val) {
      return _onClick(colId, val);
    },
    IconComponent: function IconComponent() {
      return /*#__PURE__*/_react["default"].createElement(_NotifyIcon["default"], {
        fontSize: "medium",
        iconName: tableArrow
      });
    }
  }, children) : children;
  return /*#__PURE__*/_react["default"].createElement(_TableHeaderCell.StyledTableHeadCell, {
    align: align,
    style: styles
  }, childrenWithSortLabel);
};
TableHeaderCell.propTypes = {
  children: _propTypes["default"].node.isRequired,
  sortable: _propTypes["default"].bool,
  colId: _propTypes["default"].string,
  orderByColId: _propTypes["default"].string,
  order: _propTypes["default"].string,
  align: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  styles: _propTypes["default"].instanceOf(Object)
};
TableHeaderCell.defaultProps = {
  sortable: false,
  colId: null,
  orderByColId: null,
  order: 'asc',
  align: 'left',
  onClick: function onClick() {},
  styles: null
};
var _default = exports["default"] = TableHeaderCell;